import { render } from "./InventoryBoard.vue?vue&type=template&id=93cc1358&scoped=true"
import script from "./InventoryBoard.vue?vue&type=script&lang=js"
export * from "./InventoryBoard.vue?vue&type=script&lang=js"

import "./InventoryBoard.vue?vue&type=style&index=0&id=93cc1358&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-93cc1358"]])

export default __exports__